<template>
  <SOSlotBase :loading="!detailMesin.data" :bg-grey="true">
    <template v-slot:title-bar>
      <SOTitleBar page-title="Detail Mesin" type="back" @back="back" />
    </template>
    <template v-slot:content>
      <template v-if="detailMesin.data">
        <SOConnectionStatus
          :id-mesin="detailMesin.data.id"
          :connection="reportConnection"
          :ol="detailMesin.data.snap_report_device.ol"
        />
        <SOCommonDetailMesin
          :nama="detailMesin.data.nama"
          :jenis="detailMesin.data.jenis"
          :kategori="detailMesin.data.snap_tag.nama"
          :sensor="detailMesin.data.door"
          :status-pintu="detailMesin.data.snap_report_device.door"
          :sw="detailMesin.data.snap_report_device.sw"
          :ol="detailMesin.data.snap_report_device.ol"
          @onMesin="onMesin"
          @offMesin="offMesin"
        />
        <SOTransaksiDetailMesin
          :id="detailMesin.data.id"
          :layanan="layanan"
          :sw="detailMesin.data.snap_report_device.sw"
          :tl="detailMesin.data.snap_report_device.tl"
          :aid="detailMesin.data.snap_report_device.aid"
        />
        <SODeviceDetail
          :id-device="detailMesin.data.id"
          :snapSerial="detailMesin.data.snap_serial"
          :tarif="detailMesin.data.snap_tarif.tarif"
          :firm-ware="detailMesin.data.snap_report_device.ver"
          :lat-ver="latestVersion.data.version"
          :ol="detailMesin.data.snap_report_device.ol"
        />
        <SOActionBottom
        :id-mesin="detailMesin.data.id"
        :id-outlet="idoutlet"
        @qr="
            () => {
              modal.qr = true;
            }
            "
          @hapus="hapus"
        />
      </template>
      <SOLoadingPage v-else />
    </template>
    <template v-slot:modal>
      <SnapMesinModalTurnOn
        v-if="modal.turnOn"
        :id-mesin="detailMesin.data.id"
        @close="
          () => {
            modal.turnOn = false;
          }
        "
      />
      <SnapMesinModalTurnOff
        v-if="modal.turnOff"
        :id-mesin="detailMesin.data.id"
        @close="
          () => {
            modal.turnOff = false;
          }
        "
      />
      <SnapMesinModalQr
        v-if="modal.qr"
        :qr="detailMesin.data.paylink_qris.qrcode"
        :nama-mesin="detailMesin.data.nama"
        :id-mesin="detailMesin.data.id"
        :urutan="detailMesin.data.urutan"
        :jenis="detailMesin.data.jenis"
        @close="
          () => {
            modal.qr = false;
          }
        "
      />
      <SnapMesinModalDelete
        v-if="modal.hapus"
        :id-hapus="detailMesin.data.id"
        @close="
          () => {
            modal.hapus = false;
          }
        "
      />
<!--      <SnapMesinModalDeleteNyala />-->
    </template>
  </SOSlotBase>
</template>

<script>
import { mapGetters } from "vuex";
import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOLoadingPage from "@/so-components/global/ui/SOLoadingPage";

import SOCommonDetailMesin from "./component/SOCommonDetailMesin";
import SOConnectionStatus from "./component/SOConnectionStatus";
import SOTransaksiDetailMesin from "./component/SOTransaksiDetailMesin";
import SODeviceDetail from "./component/SODeviceDetail";
import SOActionBottom from "./component/SOActionBottom";
import SnapMesinModalTurnOn from "./modal/SnapMesinModalTurnOn";
import SnapMesinModalTurnOff from "@/modules/outlet/mesin/views/modal/SnapMesinModalTurnOff";
import SnapMesinModalQr from "@/modules/outlet/mesin/views/modal/SnapMesinModalQr";
import SnapMesinModalDelete from "@/modules/outlet/mesin/views/modal/SnapMesinModalDelete";
// import SnapMesinModalDeleteNyala from "@/modules/outlet/mesin/views/modal/SnapMesinModalDeleteNyala";

export default {
  name: "SnapMesinDetail",
  components: {
    // SnapMesinModalDeleteNyala,
    SnapMesinModalDelete,
    SnapMesinModalQr,
    SnapMesinModalTurnOff,
    SnapMesinModalTurnOn,
    SOActionBottom,
    SODeviceDetail,
    SOTransaksiDetailMesin,
    SOCommonDetailMesin,
    SOLoadingPage,
    SOConnectionStatus,
    SOTitleBar,
    SOSlotBase,
  },
  data() {
    return {
      modal: {
        turnOn: false,
        turnOff: false,
        qr: false,
        hapus: false,
        hapusNyala: false,
        onOffMesinCalled: false,
      },
      idoutlet: "",
    };
  },
  sockets: {
    connect: () => {
      console.log("soket konek");
    },
  },
  methods: {
    updateMesin(report) {
      let mesin = this.detailMesin.data.snap_report_device;

      mesin.sw = report.sw;
      mesin.tl = report.tl;
      mesin.aid = report.aid;
      mesin.door = report.door;
    },

    async subcribeMesin() {
      let mesin = this.detailMesin.data;
      await this.sockets.subscribe("report.switch." + mesin.id, (r) =>
        this.updateMesin(r)
      );
      await this.sockets.subscribe("report.switch.off." + mesin.id, (r) =>
        this.updateMesin(r)
      );
      await this.sockets.subscribe("report.door." + mesin.id, (r) =>
        this.updateMesin(r)
      );
    },
    async unsubcribeMesin() {
      let mesin = this.detailMesin.data;
      await this.sockets.unsubscribe("report.switch." + mesin.id);
      await this.sockets.unsubscribe("report.switch.off." + mesin.id);
      await this.sockets.unsubscribe("report.door." + mesin.id);
    },

    async mesinDetail() {
      const query = this.$route.query;
      const res = await this.$store.dispatch(
        "snapMesinModule/fetchDetailMesin",
        query
      );
      await this.transaksiAid(this.detailMesin.data.snap_report_device.aid);
      if (res.success) {
        await this.subcribeMesin();
      }
    },
    async getConnectionReportMesin() {
      const query = this.$route.query;
      await this.$store.dispatch(
        "snapMesinModule/fetchReportConnectionMesin",
        query
      );
    },
    async transaksiAid(aid) {
      if (aid && aid !== "BOS" && aid !== "") {
        await this.$store.dispatch("snapMesinModule/fetchLayananByAid", aid);
      }
    },
    async latestVersionMesin() {
      await this.$store.dispatch("snapMesinModule/fetchLatestVersionMesin");
    },
    back() {
      this.$router.push({
        name: "ListSnapMesin",
        query: {
          idoutlet: this.idoutlet,
        },
      });
    },

    hapus() {
      // if (this.detailMesin.data.snap_report_device.sw) {
      //   $("#modal-hapus-mesin-nyala").modal("show");
      // } else {
        this.modal.hapus = true;
      // }
    },

    onMesin() {
      if (!this.onOffMesinCalled) {
        this.modal.turnOn = !this.modal.turnOn;
        this.onOffMesinCalled = true;
      }
      setTimeout(() => {
        this.onOffMesinCalled = false;
      }, 100);
    },

    offMesin() {
      if (!this.onOffMesinCalled) {
        this.modal.turnOff = !this.modal.turnOff;
        this.onOffMesinCalled = true;
      }
      setTimeout(() => {
        this.onOffMesinCalled = false;
      }, 100);
    },

    async flushData() {
      await this.$store.commit("snapMesinModule/resetDetail");
      await this.$store.commit("snapMesinModule/resetLatVer");
    },
  },
  mounted() {
    this.mesinDetail();
    this.getConnectionReportMesin();
    this.latestVersionMesin();

    this.idoutlet = this.$route.query.idoutlet;
  },
  beforeDestroy() {
    this.unsubcribeMesin();
    this.flushData();
  },
  computed: {
    ...mapGetters("snapMesinModule", {
      detailMesin: "getDetailMesin",
      reportConnection: "getReportConnectionMesin",
      layanan: "getLayananByAid",
      latestVersion: "getLatestVersionMesin",
    }),
  },
};
</script>

<style scoped>
</style>